import moment from 'moment'

export default function today() {
  return moment().startOf('day').clone().toDate()
}



// WEBPACK FOOTER //
// ./client/redux/modules/today.js